import { useStateRef } from "hooks/useStateRef";
import React, { createContext, useContext } from "react";

export const PopupManagerContext = createContext();

export const PopupManagerProvider = ({ children }) => {
  const [curOpen, setCurOpen, curOpenRef] = useStateRef();

  return (
    <PopupManagerContext.Provider
      value={{
        curOpen,
        curOpenRef,
        setCurOpen,
      }}
    >
      {children}
    </PopupManagerContext.Provider>
  );
};

export const usePopupManagerContext = () => useContext(PopupManagerContext);
